export default __webpack_public_path__ + "static/us-image-21abc956be99604827396f7593e2892f.jpg";